export const displayErrorFn = () => {
	if (["development", "preproduction", "goroco"].includes(import.meta.env.VITE_APP_ENVIRONMENT)) return true;

	return false;
};
